import tribunalAPI from "api/tribunalAPi";

export const getEncuesta = async (idEncuesta: number): Promise<any> => {
    const url = `encuesta/${idEncuesta}`;
    const responseData = (await tribunalAPI.get(url));
    return responseData;
};
export const getPreguntasHijas = async (idPregunta: number): Promise<any> => {
    const url = `encuesta/preguntas-hijas/${idPregunta}`;
    const responseData = (await tribunalAPI.get(url));
    return responseData;
};

export const postEncuesta = async (body: any): Promise<any> => {
    const url = `encuesta`;
    const responseData = (await tribunalAPI.post(url, body));
    return responseData;
};
export const getVerificaEncuesta = async (idEncuesta: number, cveUsuario: number): Promise<any> => {
    const url = `encuesta/verificar-respuesta-usuario/${idEncuesta}/${cveUsuario}`;
    const responseData = (await tribunalAPI.get(url));
    return responseData;
};